import Gratuity from './src/main';

/* istanbul ignore next */
Gratuity.install = function(Vue) {
  Vue.component(Gratuity.name, Gratuity);
};

export default Gratuity;
